module.exports = __webpack_public_path__ + "astandes.png?a9e4130b7c746ac2a5e0fa99b198ba2c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/astandes.png
// module id = 240
// module chunks = 0